// extracted by mini-css-extract-plugin
module.exports = {"stampPanel":"StampPanel_stampPanel__1JNyZ"};